import React from "react";
import { FaEdit } from "react-icons/fa";
import EditEmailAddress from "./EditEmailAddress";
import Skeleton from "react-loading-skeleton";

const capitalize = (str) =>
  str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : "";

const EmailAddress = ({ userProfile, isLoading, refetch }) => {
  return (
    <>
      <div className="d-flex justify-content-between mb-2">
        <h4 className="small-text font-weight-bold">Email Addresses: <span style={{ color: '#8e3039' }}>*</span></h4>
        <button
          className="btn btn-outline-primary btn-edit-user-profile"
          data-toggle="modal"
          data-target="#editEmailAddress"
        >
          <FaEdit size={16} className="mr-2" /> Edit
        </button>
        <EditEmailAddress
          userProfile={userProfile}
          isLoading={isLoading}
          refetch={refetch}
        />
      </div>
      <div className="row small-text">
        <div className="col-md-6">
          {/* Primary email always shown first */}
          {(userProfile?.email || isLoading) && (
            <div className="row">
              <div className="col-md-4">
                <p>Primary Email Address:</p>
              </div>
              <div className="col-md-8 d-flex">
                <p className="font-weight-bold">
                  {userProfile?.email
                    ? userProfile.email
                    : isLoading && <Skeleton width={100} height={20} />}
                </p>
              </div>
            </div>
          )}

          {/* Additional emails from the emails array — skip primary (shown above) */}
          {userProfile?.emails
            ?.filter((email) => email.type?.toLowerCase() !== "primary" && email.value !== userProfile?.email)
            .map((email) => (
            <div className="row" key={email.id}>
              <div className="col-md-4">
                <p>{capitalize(email.type)} Email Address:</p>
              </div>
              <div className="col-md-8 d-flex">
                <p className="font-weight-bold">{email.value}</p>
                {email.preferred && (
                  <div className="ml-3 badge_pomme bg_primary f-10 text-light rounded-pill d-flex align-items-center justify-content-center">
                    <span>Preferred Email Address</span>
                  </div>
                )}
              </div>
            </div>
          ))}

          {isLoading && !userProfile && (
            <div className="row">
              <div className="col-md-4"><Skeleton width={120} height={16} /></div>
              <div className="col-md-8"><Skeleton width={160} height={16} /></div>
            </div>
          )}
        </div>
      </div>
      <hr />
    </>
  );
};

export default EmailAddress;
